import TaskaShkspr from 'assets/img/taska-shkspr.svg'
import classNames from 'classnames'
import { ContactForm, FullpageLoading, Menu, MeteorPaymentForm, StripePaymentForm, PaymentSummary } from 'components'
import messages from 'i18n/messages'
import update from 'immutability-helper'
import flowRight from 'lodash/flowRight'
import isEmpty from 'lodash/isEmpty'
import { makeSelectCustomer, isValidEmail } from 'logic/customers'
import { makeSelectCurOrg, makeSelectPortalSettings } from 'logic/orgs'
import { makeSelectPaymentData } from 'logic/payment'
import { createVoucher, makeSelectAgreeTerms, makeSelectDeliveryMethod, makeSelectStatus, makeSelectValue, makeSelectVoucher, saveVoucher, setAgreeTerms, setDeliveryMethod, setDesignation, setValue, unsetVoucher } from 'logic/vouchers'
import Head from 'next/head'
import { Component } from 'react'
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Alert, Button, Col, Container, Form, FormGroup, FormText, Input, Label, Row } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { EMAIL_REGEX } from '../../lib/misc'

const formattedVoucherTerms = ({ portal: { voucher_terms }, name }) =>
  voucher_terms
    .replace(/\(Variable\)/g, name)
    .replace(/\{ORG_NAME\}/g, name)

const PayNowBtn = ({ canContinue, loading, handleSubmit }) => (
  <Button
    color="primary"
    block
    className="tt-primary-bg-color tt-primary-border-color"
    disabled={!canContinue || loading}
    onClick={handleSubmit}
  >
    {loading
      ? <Loading color={outline ? 'primary' : 'white'} width="1.5em" />
      : <FormattedMessage {...messages.continueToPayment} />
    }
  </Button>
)

const VoucherTerms = ({ collapseTerms, org, agreedTerms, handleToggleAgreeTerms, handleToggleCollapsed }) => (
  <div>
    <div className={`voucher-terms${collapseTerms ? ' collapsed' : ''}`}>
      <div className="section-header">
        {agreedTerms
          ? <>
              <div className="agreed-terms">
                <FormattedMessage {...messages.status} />:&nbsp;
                                <span className="text-success"><FormattedMessage {...messages.agreedTerms} /></span>
              </div>
              <span className={`tt-icon tt-icon-${collapseTerms ? 'down' : 'up'}-arrow`} onClick={handleToggleCollapsed} />
            </>
          : null
        }
      </div>
      <div className="voucher-terms-details">
        <h2><FormattedMessage {...messages.termsAndConditions} /></h2>
        <div className="terms-text" dangerouslySetInnerHTML={{ __html: formattedVoucherTerms(org) }}></div>
        <div className="terms-control">
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                checked={agreedTerms || false}
                onChange={handleToggleAgreeTerms}
              />
              <span className="form-check-sign" />
              <FormattedMessage {...messages.agreeTerms} />
            </Label>
          </FormGroup>
        </div>
      </div>
    </div>
  </div>
)

const VouchersNotEnabledByOrg = ({ org }) => (
  <div className="hero">
    <h2 className="text-danger"><FormattedMessage {...messages.vouchersDisabled} /></h2>
    <p><FormattedMessage {...messages.vouchersDisabledDesc} values={org} /></p>
    <img className="hero-img" src={TaskaShkspr} alt="" />
  </div>
)

class Voucher extends Component {

  state = {
    collapseTerms: false,
    collapseContact: false,
    collapseShipping: false,
    emailError: null,
  }
  
  componentDidMount () {
    if (!this.props.org) return

    const { voucher_min_value, voucher_default_value } = this.props.org.portal
    this.props.actions.setValue(voucher_default_value || voucher_min_value || 20)
    this.props.actions.unsetVoucher()
  }

  handleResetEmailError = () => this.setState({ emailError: false })
  
  handleToggleAgreeTerms = () =>
    this.setState({ collapseTerms: !this.props.agreedTerms }, () =>
      this.props.actions.setAgreeTerms(!this.props.agreedTerms)
    )

  handleToggleCollapsed = () =>
    this.setState(update( this.state, { collapseTerms: { $set: !this.state.collapseTerms } }))

  handleSetDeliveryMethod = ({ target: { value }}) => {
    this.setState(update(this.state, {
      collapseShipping: { $set: true },
    }))
    this.props.actions.setDeliveryMethod(value)
    this.updateCheckoutId()
  }
 
  updateCheckoutId = async () => {
    const { voucher } = this.props
    if (!voucher) return

    await this.props.actions.saveVoucher(voucher.id)
  }

  handleSubmit = e => {
    e.preventDefault()
    window.f = this.form
    if (typeof(this.form.checkValidity) === 'function' && !this.form.checkValidity()) return

    if (!this.props.customer ||
        !this.props.customer.email ||
        !this.props.customer.firstname ||
        !this.props.customer.lastname ||
        !EMAIL_REGEX.test(this.props.customer.email)) {
      this.setState({ emailError: true })
      return
    }

    // this.props.actions.setDeliveryMethod('pdf')
    this.setState(update( this.state, {
      collapseContact: { $set: true },
      collapseShipping: { $set: true },
    }))
    if (this.props.voucher && this.props.voucher.id) {
      this.props.actions.saveVoucher(this.props.voucher.id)
      return
    }
    this.props.actions.createVoucher()
  }

  handleToggleCollapsedContact = () =>
    this.setState(update( this.state, { collapseContact: { $set: !this.state.collapseContact } }))

  handleToggleCollapsedShipping = () =>
    this.setState(update(this.state, { collapseShipping: { $set: !this.state.collapseShipping } }))

  getSetValueHandler = increase => () => {
      if (this.props.status === 'loading') return
      
      const newVal = increase ? this.props.value + 5 : this.props.value - 5

      if (newVal > (this.props.portal.voucher_max_value || 500) || newVal < (this.props.portal.voucher_min_value || 5)) return

      this.props.actions.setValue(newVal)
      setTimeout(this.updateCheckoutId, 500)
    }

  handleSetDesignation = (_key, value) =>
    this.props.action.setDesignation(value)

  renderDeliveryMethods = (deliveryMethod, fees) => (
    <div className={classNames('delivery-methods', { collapsed: this.state.collapseShipping })}>
      <div className="section-header">
        <h2>
          <FormattedMessage {...messages.shipping} />
        </h2>
        <div className="agreed-terms">
          {deliveryMethod && messages[`shipping_${deliveryMethod}`]
            ? <FormattedMessage {...messages[`shipping_${deliveryMethod}`]} />
            : deliveryMethod
          }
        </div>
        <span className={`tt-icon tt-icon-${this.state.collapseShipping ? 'down' : 'up'}-arrow`} onClick={this.handleToggleCollapsedShipping} />
      </div>
      <div className="collapsed-content">
        <Row>
          <Col lg="6">
            <FormGroup check className="form-check-radio">
              <Label check>
                <Input
                  type="radio"
                  name="delivery_method"
                  value="pdf"
                  checked={deliveryMethod === 'pdf'}
                  onChange={this.handleSetDeliveryMethod}
                />
                <span className="form-check-sign" />
                <FormattedMessage {...messages.deliveryMethodpdf} />
                <FormText>
                  <FormattedMessage {...messages.deliveryMethodpdfVoucherDesc} />
                </FormText>
              </Label>
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup check className="form-check-radio">
              <Label check>
                <Input
                  type="radio"
                  name="delivery_method"
                  value="post"
                  checked={deliveryMethod === 'post'}
                  onChange={this.handleSetDeliveryMethod}
                />
                <span className="form-check-sign" />
                <FormattedMessage {...messages.shipping_post} />
                <FormText>
                  <FormattedMessage {...messages.voucherAdditionalFees} values={{ fees }} />
                </FormText>
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </div>
  )

  canContinue = () => {
    if (this.props.status === 'missing_data') return false

    const { customer } = this.props

    if (!this.props.agreedTerms) return false
    if (isEmpty(customer.email)) return false
    if (customer.meta && customer.meta.atsx_num) {
      if (new RegExp(atsxRegex).test(customer && customer.meta.atsx_num)) return true // shortcut to exit for oescv
      if (this.state.error !== ATSX_REGEX)
        this.setState(update(this.state, { error: { $set: ATSX_REGEX } }))
    }
    if (isEmpty(customer.firstname)) return false
    if (isEmpty(customer.lastname)) return false
    if (!isValidEmail(customer.email)) return false
    if (this.props.deliveryMethod === 'post' && customer.addresses.length > 0) {
      if (isEmpty(customer.addresses[0].street)) return false
      if (isEmpty(customer.addresses[0].city)) return false
      if (isEmpty(customer.addresses[0].country_code)) return false
      if (isEmpty(customer.addresses[0].postcode)) return false
    }
    return true
  }

  render() {
    const { status, org, intl: { formatMessage, formatNumber }, value, deliveryMethod } = this.props
    const { portal: { voucher_min_value, voucher_max_value } } = this.props
    const loading = status && status.includes('loading')

    if (!org) return <FullpageLoading />

    const fees = formatNumber(org.portal.voucher_shipping_fees / 100, { currency: org.currency, style: 'currency' })

    if (!org.portal.vouchers_enabled || !org.portal.voucher_terms) return <VouchersNotEnabledByOrg org={org} />

    return (
      <div>
        <Head>
          <title>{`${formatMessage(messages.ticketShop, org)}`}</title>
          <meta name="robots" content="noindex, nofollow" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </Head>
        <Menu />
        <div className="tt-select-tickets">
          <div className="book-header">
            <div className="tickets-text">{isEmpty(org.portal.voucher_text) ? <FormattedMessage {...messages.buyGiftCard} /> : org.portal.voucher_text}</div>
          </div>
        </div>
        <Container className="mb-4">
          <Form onSubmit={this.handleSubmit} id="voucher-main-form" ref={form => this.form = form}>
            <div className="tt-book-settings">
              <div className="qty-form-control">
                <h2>
                  <FormattedMessage {...messages.voucherValue} />
                </h2>
                <div className="qty-switches">
                  <div className={classNames('qty-btn', { disabled: (loading || value <= (voucher_min_value || 5)) })} onClick={this.getSetValueHandler(false)}>
                    <span className="tt-icon tt-icon-i-delete" />
                  </div>
                  <div className="qty-value">
                    <FormattedNumber currency={org.currency} style={`currency`} value={value} />
                  </div>
                  <div className={classNames('qty-btn', { disabled: (loading || value >= (voucher_max_value || 500)) })} onClick={this.getSetValueHandler(true)}>
                    <span className="tt-icon tt-icon-i-add" />
                  </div>
                </div>
              </div>
              { org.portal.voucher_shipping && org.portal.voucher_shipping_fees
                ? this.renderDeliveryMethods(deliveryMethod, fees)
                : null
              }
              <ContactForm
                collapsed={this.state.collapseContact}
                toggleCollapsed={this.handleToggleCollapsedContact}
                deliveryMethod={deliveryMethod}
                resetEmailError={this.handleResetEmailError}
                emailError={this.state.emailError}
                isVoucher
              />
              {this.props.paymentData && this.props.customer.changed
                ? <Button color="primary" block onClick={this.handleSubmit}>
                    <FormattedMessage {...messages.updateContactData} />
                  </Button>
                : null
              }
            </div>
          </Form>
          {this.props.paymentData
            ? null
            : <PaymentSummary
                values={[{ value: value * 100, amount: 1, description: formatMessage(messages.giftCard) }]}
                status={status}
                payable={this.props.voucher}
                handleSubmit={this.handleSubmit}
                deliveryMethod={deliveryMethod}
              />
          }
          <VoucherTerms
            handleToggleCollapsed={this.handleToggleCollapsed}
            handleToggleAgreeTerms={this.handleToggleAgreeTerms}
            collapseTerms={this.state.collapseTerms}
            {...this.props}
          />
          {this.state.emailError
            ? <div>
                <div className="ticket-terms">
                  <div className="ticket-terms-details">
                    <Alert color="warning"><FormattedMessage {...messages.invalidEmail} /></Alert>
                  </div>
                </div>
              </div>
            : null
          }
          {this.props.paymentData
            ? null
            : <PayNowBtn
                canContinue={this.canContinue()}
                handleSubmit={this.handleSubmit}
              />
          }
          {this.props.paymentData && !this.props.paymentData.stripe_client_token
            ? <MeteorPaymentForm
                {...this.props}
                hide={this.props.customer.changed}
                values={[{ value: value * 100, amount: 1, description: formatMessage(messages.giftCard) }]}
                payable={this.props.voucher}
                deliveryMethod={deliveryMethod}
              />
            : null
          }
          {this.props.paymentData && this.props.paymentData.stripe_client_token
            ? <StripePaymentForm
              {...this.props}
              hide={this.props.customer.changed}
              values={[{ value: value * 100, amount: 1, description: formatMessage(messages.giftCard) }]}
              payable={this.props.voucher}
              deliveryMethod={deliveryMethod}
            />
            : null
          }
        </Container>
      </div>
    )
  }

}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  value: makeSelectValue(),
  voucher: makeSelectVoucher(),
  status: makeSelectStatus(),
  paymentData: makeSelectPaymentData(),
  portal: makeSelectPortalSettings(),
  agreedTerms: makeSelectAgreeTerms(),
  deliveryMethod: makeSelectDeliveryMethod(),
  customer: makeSelectCustomer(),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    saveVoucher,
    setValue,
    setAgreeTerms,
    setDesignation,
    setDeliveryMethod,
    createVoucher,
    unsetVoucher,
  }, dispatch)
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(Voucher);
